<template>
  <div></div>
</template>

<script>
import { openLogin } from '@/utils/loginModal'
import { getToken } from '@/utils/auth'

export default {
  name: 'LoginRedirectView',
  mounted() {
    const redirect = this.$route.query.redirect
    const target = typeof redirect === 'string' && redirect.startsWith('/') ? redirect : '/workbench'
    if (!getToken()) {
      this.$router.replace(target).then(() => {
        this.$nextTick(() => openLogin(target))
      })
    } else {
      this.$router.replace(target)
    }
  }
}
</script>
